import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';

const MainPage = () => {
  const [quizList, setQuizList] = useState([]);

  useEffect(() => {
    fetch('/assets/list.json')
      .then(res => res.json())
      .then(data => setQuizList(data))
      .catch(err => console.error('JSON 불러오기 실패:', err));
  }, []);

  return (
    <main style={{ padding: '20px', backgroundColor: '#0c0d14' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div className="desktop-top">
          {quizList[0] && (
            <a href={quizList[0].url} className="main-card">
              <img src={quizList[0].img} alt={quizList[0].title} className="card-img" />
              <div className="card-desc">
                <strong>{quizList[0].title}</strong><br />
                <span style={{ fontSize: '13px', color: '#333' }}>{quizList[0].desc}</span>
              </div>
            </a>
          )}

          <div className="side-cards" style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', width: '100%' }}>
            {quizList.slice(1, 3).map((quiz, idx) => (
              <a key={quiz.id} href={quiz.url} className="mini-card" style={{ flex: '1 1 calc(50% - 8px)' }}>
                <img src={quiz.img} alt={quiz.title} className="card-img" />
                <div className="card-desc">
                  <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>{quiz.title}</div>
                  <div style={{ fontSize: '12px', color: '#555' }}>{quiz.desc}</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="grid-layout">
          {quizList.slice(3).map(quiz => (
            <a key={quiz.id} href={quiz.url} className="mini-card">
              <img src={quiz.img} alt={quiz.title} className="card-img" />
              <div className="card-desc">
                <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>{quiz.title}</div>
                <div style={{ fontSize: '12px', color: '#555' }}>{quiz.desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </main>
  );
};

function App() {
  return (
    <Router>
      {/* 헤더 */}
      <div style={{ backgroundColor: '#1f2030', padding: '8px 16px' }}>
        <div style={{
          maxWidth: '600px',
          margin: '0 auto',
          color: 'white',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Link to="/" style={{ display: 'inline-block' }}>
            <img
              src="/assets/title.png?v=3"
              alt="Autonam 로고"
              style={{
                height: '40px',
                marginRight: '12px',
                flexShrink: 0,
                cursor: 'pointer'
              }}
            />
          </Link>
        </div>
      </div>

      {/* 라우팅 */}
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </Router>
  );
}

export default App;
